import { createContext, useContext, useState, useEffect } from 'react'
import { runVerificaAutenticacao } from '../services/api'
import { useNavigate } from 'react-router-dom'

const AuthenticationContext = createContext()

export function AuthenticationProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const verificaAutenticacao = async () => {
      const response = await runVerificaAutenticacao()

      console.log('response', response)

      const { status } = response

      console.log('status', status)

      if (status === 'error') {
        setIsAuthenticated(false)
        navigate('/login')
        return
      }

      setIsAuthenticated(true)

      console.log('response', response)
    }

    verificaAutenticacao()
  }, [])

  return (
    <AuthenticationContext.Provider value={{ isAuthenticated }}>
      {children}
    </AuthenticationContext.Provider>
  )
}

export function useAuthentication() {
  const context = useContext(AuthenticationContext)

  if (!context) {
    throw new Error(
      'useAuthentication must be used within an AuthenticationProvider'
    )
  }

  return context
}
